import { type ListTemplateLayout } from "components/ListTemplate/types";
import { cardLayout } from "./cardLayout";
import { tableLayout } from "./tableLayout";
import { type ViewportType } from "utilities/hookutils";

const toggleableLayout = (viewport: ViewportType, viewModel: server.viewmodel.ShowListInternalFrontModel): ListTemplateLayout<server.dto.ShowForListInternal> => ({
  type: "both",
  toggleCacheKey: "show",
  sections: cardLayout(viewModel),
  columns: tableLayout(viewport, viewModel)
});

export default toggleableLayout;
